import { buildClassName, lookupPreset } from "./util";

// id: "4e8c0de8-0ae1-4904-b4e2-6d7645aed1dd"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter4e8c0de80ae14904B4e26d7645aed1dd(props: any) {
  const Navigation = lookupPreset("Navigation");
  const Logo = lookupPreset("Logo");
  const GroupCopyright = lookupPreset("GroupCopyright");
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter4e8c0de80ae14904B4e26d7645aed1dd footer`}>
      {props["links"] || <Navigation className="Links6bb969ab9b9e4f6294e917ab363e7b4c" parentTag={buildClassName("Links6bb969ab9b9e4f6294e917ab363e7b4c", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo36920bf9Fb1945fe8a5aAf9893f56a42" parentTag={buildClassName("Logo36920bf9Fb1945fe8a5aAf9893f56a42", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright690b4542D6c64a94B03dA789e3aeea30" parentTag={buildClassName("Copyright690b4542D6c64a94B03dA789e3aeea30", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowAd6be652124d4aa9A054E8d075c70771" parentTag={buildClassName("GroupflowAd6be652124d4aa9A054E8d075c70771", parentTag)} {...props} />}
    </footer>
  );
}

// id: "36920bf9-fb19-45fe-8a5a-af9893f56a42"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "4e8c0de8-0ae1-4904-b4e2-6d7645aed1dd"
export function Logo36920bf9Fb1945fe8a5aAf9893f56a42(props: any) {
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo36920bf9Fb1945fe8a5aAf9893f56a42" parentTag={buildClassName("Logo36920bf9Fb1945fe8a5aAf9893f56a42", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "690b4542-d6c6-4a94-b03d-a789e3aeea30"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "4e8c0de8-0ae1-4904-b4e2-6d7645aed1dd"
export function Copyright690b4542D6c64a94B03dA789e3aeea30(props: any) {
  const GroupCopyright = lookupPreset("GroupCopyright");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright690b4542D6c64a94B03dA789e3aeea30" parentTag={buildClassName("Copyright690b4542D6c64a94B03dA789e3aeea30", parentTag)} {...props} />
  );
}

// id: "6bb969ab-9b9e-4f62-94e9-17ab363e7b4c"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "4e8c0de8-0ae1-4904-b4e2-6d7645aed1dd"
export function Links6bb969ab9b9e4f6294e917ab363e7b4c(props: any) {
  const Navigation = lookupPreset("Navigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links6bb969ab9b9e4f6294e917ab363e7b4c" parentTag={buildClassName("Links6bb969ab9b9e4f6294e917ab363e7b4c", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "ad6be652-124d-4aa9-a054-e8d075c70771"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "4e8c0de8-0ae1-4904-b4e2-6d7645aed1dd"
export function GroupflowAd6be652124d4aa9A054E8d075c70771(props: any) {
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowAd6be652124d4aa9A054E8d075c70771" parentTag={buildClassName("GroupflowAd6be652124d4aa9A054E8d075c70771", parentTag)} {...props} />
  );
}

// id: "e782cea4-f19c-4c43-be10-a99092bd7456"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "36920bf9-fb19-45fe-8a5a-af9893f56a42"
export const ContentSlugE782cea4F19c4c43Be10A99092bd7456 = "footer-logo";

// id: "3dd42064-9ae0-4339-8fb6-030525d7aeb7"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "36920bf9-fb19-45fe-8a5a-af9893f56a42"
export const LogoType3dd420649ae043398fb6030525d7aeb7 = "FOOTER";

// id: "7dff24ef-9118-4a8f-8686-3d97a29d513d"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "6bb969ab-9b9e-4f62-94e9-17ab363e7b4c"
export const NavMenuSlug7dff24ef91184a8f86863d97a29d513d = "footer-nav";

const Components = {
  DefaultFooter4e8c0de80ae14904B4e26d7645aed1dd,
  Logo36920bf9Fb1945fe8a5aAf9893f56a42,
  Copyright690b4542D6c64a94B03dA789e3aeea30,
  Links6bb969ab9b9e4f6294e917ab363e7b4c,
  GroupflowAd6be652124d4aa9A054E8d075c70771,
  ContentSlugE782cea4F19c4c43Be10A99092bd7456,
  LogoType3dd420649ae043398fb6030525d7aeb7,
  NavMenuSlug7dff24ef91184a8f86863d97a29d513d
}

export default Components;